import React, {Component} from 'react';
import { Link, List, ListItem, Box, } from '@mui/material';
import PortalTooltip from '../../common/PortalTooltip';

class ProgramResources extends Component {
    render() {
        return <List sx={{pb:0}}>
                {this.props.myProgramLinks.map(item => {
                    return (
                        <ListItem sx={{pt:0}} divider>
                            <PortalTooltip id={'myPrograms__tooltip_' + item.id} title={item?.tooltipTitle} >                                        
                                <Link rel={item.rel} target={item.target} href={item.link} underline={'hover'} >
                                    {item.title}
                                </Link>
                            </PortalTooltip>
                        </ListItem>
                    );
                })}
            </List>
    }
}

export default ProgramResources;
